<div [id]="uuid" class="silobag-map" [style.height]="height"></div>
